import PropTypes from "prop-types";
import Helmet from "react-helmet";

const PageTitle = () => {
  return (
    <Helmet>
      <title>Unified Identity Governance Portal</title>
    </Helmet>
  );
};

PageTitle.propTypes = {
  title: PropTypes.object,
};

export default PageTitle;
